export default __webpack_public_path__ + "static/media/sat-blue.d187b752.png";